import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getImgSrc } from '../../services/common/CommonUtils';

const SpecialDealsCard = ({ offerItem, psmItem }) => {
  // console.log('offerItem', offerItem);

  const navigate = useNavigate();

  const handleViewDetails = (e) => {
    e.preventDefault();

    navigate(`/special-deals-detail/${offerItem?.offercode}`, {
      state: { psmItem: psmItem },
    });
  };

  return (
    <div className="card_style_2 height_100" onClick={handleViewDetails}>
      <div className="card_img">
        {offerItem?.fifa && (
          <div className="offer_placeholder end-0 top-0">
            <img
              src={process.env.PUBLIC_URL + '/assets/images/offer-icon.png'}
              alt=""
              title=""
            />
          </div>
        )}
        {offerItem?.isitsurpriseoffer && (
          <div className="offer_placeholder end-0 top-0">
            <img
              src={process.env.PUBLIC_URL + '/assets/images/icon/offer-icon-special.png'}
              alt=""
              title=""
            />
          </div>
        )}
        <img
          // src={
          //   offerItem?.image ||
          //   process.env.PUBLIC_URL + '/assets/images/s-internet.svg'
          // }
          src={getImgSrc(offerItem?.image, true)}
          alt=""
          title=""
        />
      </div>
      <div className="card_info">
        <div className="card_info_grp">
          <h4>{offerItem?.title}</h4>
          <p>{offerItem?.description}</p>
        </div>
        <div className="card_link flex_grp_align_center">
          {
            offerItem?.discountedprice > 0 && (
              <div className="amount_stripe me-2">{offerItem?.currency || ''} {offerItem?.amount || ''}</div>
            )
          }
          
          <div className="hyperlink" onClick={handleViewDetails}>
            {offerItem?.currency || ''} {offerItem?.discountedprice > 0 ? offerItem?.discountedprice : offerItem?.amount}
            <span className="text-lowercase">
              {offerItem?.validity ? `/${offerItem?.validity}` : ''}
            </span>
            <img
              src={
                process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'
              }
              alt=""
              title=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpecialDealsCard;
